<!-- 邮箱订阅不可删除 -->
<template>
  <section
    style="max-width: 100%"
    class="email w-full flex flex-center flex-wrap gap-2"
    :style="{ backgroundColor: datas.backgroundColor }"
  >
    <div class="flex-col gap-2">
      <div id="item" class="item font-bold">
        <sps-text :text="datas.title" :value="datas.title_font" />
      </div>
      <div v-html="HtmlUtil.escape2Html(datas.subTitle)" />
      <div v-if="!seninfo" class="input-wrapper max-w-500px min-w-275px flex text-left md:mt-10px">
        <n-input
          v-model:value="email"
          :placeholder="$t('message.placeholder')"
          class="h-10.5 flex-1 align-middle md:h-[50px] rounded-none!"
        />
        <n-button type="primary" class="h-10.5 min-w-15 md:h-[50px] rounded-none! !text-left" @click="successEvent">
          <!-- <p>{{ $t('subscribe') }}</p> -->
          <icon name="icon:arrow1" class="h-16px w-16px" />
        </n-button>
      </div>
      <div v-else class="w-275px flex-center text-left">
        <p class="text-xl">
          {{ $t('message.subscribeSuccess') }}
        </p>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { useMessage } from 'naive-ui'
import { Subscription } from '~/services/api'
import { HtmlUtil } from '~/utils/common/htmlDecode'

defineOptions({
  name: 'MailSubscription',
})
defineProps<{
  datas?: any
}>()
const { t } = useI18n()
const seninfo = ref(false)
const message = useMessage()
const email = ref<any>()

const successEvent = async () => {
  const emailRegex = /^[\w.-]+@[\w.-]+\.\w+$/
  const data = { email: email.value }

  // 验证邮箱格式
  if (!emailRegex.test(email.value)) {
    message.error(t('message.emailError'))
    email.value = ''
    return
  }

  // 请求接口
  const res: any = await Subscription(data)
  if (res.data?.code == 200 && res.data?.state == 'ok') {
    if (res.data?.subscribe == 2) {
      message.info(t('message.subscribeHas'))
    }
    else {
      seninfo.value = true
      message.success(t('message.subscribeSuccess'))
    }
  }
  else {
    message.error(res.error.msg)
  }
}
</script>

<style scoped lang="scss">
:deep(.n-form-item.n-form-item--top-labelled.n-form-item--no-label) {
  grid-template-areas: 'blank';
  grid-template-rows: 1fr;
}
:deep(.n-input .n-input__input-el) {
  height: 100%;
}
:deep(.n-button__content) {
  justify-content: center;
}
</style>
